export default __webpack_public_path__ + "static/media/Capture.c2516210.PNG";